module.exports = __webpack_public_path__ + "static/media/nexuses-01.4b82fe36.png";